import axios from "axios";

/* Create New Label */

export const createNewLabel = async (labelName) => {
  try {
    const response = await axios.post(
      "http://localhost:8080/label/create-label",
      {
        name: labelName,
      },
    );
    return response;
  } catch (error) {
    console.error("createNewLabel: API call failed");
    console.error("Error object:", error);
    console.error("API error:", error); // Add this
    return error.response;
  }
};

//---------------GET LABEL---------------------

export const getAllLabels = async () => {
  try {
    const response = await axios.get(
      "http://localhost:8080/label/get-all-label",
    );
    return response;
  } catch (error) {
    return error.response;
  }
};
